import React from 'react';
import NavigationWidget from '../NavigationWidget/NavigationWidget';

export default function NACSideBar(props) {
	// console.log('NACSideBar', props);
	return (
		<div className="NACSideBar h-100">
			<p className='title pl-2 pt-2'>{props.title}</p>
			<div className="mx-auto">
				<NavigationWidget
					icon="fa fa-sitemap"
					label="Account Type Selection"
				/>
				<hr />
				<NavigationWidget
					icon="fa fa-sitemap"
					label="Account Type Selection"
				/>
				<NavigationWidget
					icon="fa fa-sitemap"
					label="Account Type Selection"
				/>
				<NavigationWidget
					icon="fa fa-sitemap"
					label="Account Type Selection"
				/>
				<NavigationWidget
					icon="fa fa-sitemap"
					label="Account Type Selection"
				/>
				<hr />
				<NavigationWidget
					icon="fa fa-sitemap"
					label="Account Type Selection"
				/>
			</div>
		</div>
	);
}
